module.exports = __webpack_public_path__ + "static/media/bruce2.32f2608b.mp3";